import { Box, CircularProgress, Theme, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { adAuthenticate, getRoleBasedPermissions } from "../redux-store/actions/auth";
import { ADAuthenticateResponseBody, GetRoleBasedPermissionsResponseBody, PortalAccess, } from "../redux-store/types/api-types";
import { VERIFY_LOGIN_OTP_SUCCESS } from "../redux-store/types/auth";
import { decodeJwtPayload } from "../utils/utilityFunctions";

export default function LoadingAdid(): JSX.Element {
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const [error, setError] = useState<string>("");
    //Extract te query params
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get("code");

    useEffect(() => {
        if (!code) {
            setError("Authorization code not found");
            return;
        }

        (async () => {
            try {
                const response = await (dispatch(
                    adAuthenticate({ code })
                ) as unknown as Promise<ADAuthenticateResponseBody>);

                if (response) {
                    const permissionsSelectionCriteria = response?.subRole ? response?.subRole : response?.role;
                    const permissionResponse = await (dispatch(getRoleBasedPermissions({
                        temporaryToken: response?.token ?? ""
                    })) as unknown as Promise<GetRoleBasedPermissionsResponseBody>);
                    if (!permissionResponse) return;
                    const decodedToken = decodeJwtPayload<{ portalAccess?: PortalAccess }>(response?.token);

                    dispatch({
                        type: VERIFY_LOGIN_OTP_SUCCESS,
                        body: {
                            ...response,
                            portalAccess: decodedToken?.portalAccess,
                            permissions: permissionResponse?.permissions[`${permissionsSelectionCriteria ?? ""}`.toUpperCase()] ?? permissionResponse?.permissions[`${permissionsSelectionCriteria ?? ""}`.toLowerCase()] ?? permissionResponse?.permissions[permissionsSelectionCriteria] ?? []
                        }
                    });

                    history.replace("/app-launcher");
                }
                else {
                    history.replace("/login");
                }
            } catch (e) {
                console.error("CyberArk authentication failed:", e);
                setError("Authentication failed. Please try again.");
            }
        })();
    }, [code]);

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                gap: "24px",
                backgroundColor: "background.default",
            }}
        >
            <img src="/images/cyberArc.png" alt="CyberArk" width={58} height={58} style={{ objectFit: "contain" }} />
            {!error ? (
                <>
                    <CircularProgress
                        size={40}
                        sx={(theme: Theme) => ({ color: theme.palette.primary[500] })}
                    />
                    <Box sx={{ textAlign: "center" }}>
                        <Typography
                            variant="h2"
                            sx={(theme: Theme) => ({
                                color: theme.palette.text.primary,
                                marginBottom: "8px",
                            })}
                        >
                            Signing in with your credentials
                        </Typography>
                        <Typography
                            variant="subtitle_400"
                            sx={(theme: Theme) => ({
                                color: theme.palette.text.secondary,
                            })}
                        >
                            Please wait...
                        </Typography>
                    </Box>
                </>
            ) : (
                <Box sx={{ textAlign: "center" }}>
                    <Typography
                        variant="h2"
                        sx={(theme: Theme) => ({
                            color: theme.palette.error.main,
                            marginBottom: "8px",
                        })}
                    >
                        {error}
                    </Typography>
                    <Typography
                        variant="subtitle_400"
                        sx={(theme: Theme) => ({
                            color: theme.palette.primary[500],
                            cursor: "pointer",
                            "&:hover": { textDecoration: "underline" },
                        })}
                        onClick={() => history.replace("/login")}
                    >
                        Go back to login
                    </Typography>
                </Box>
            )}
        </Box>
    );
}
